import { useRef, useState, useCallback, useContext, useDebugValue, } from 'react';
import { useLayoutEffectWithoutSSRComplaining } from '@wix/da-hooks/pkg/useLayoutEffectWithoutSSRComplaining';
import { DropdownDebugContext } from '../DropdownStateManager/DropdownStateContext';
export function useDropdownState(menuRef, toggleRef, _a) {
    var disabled = _a.disabled, onOpen = _a.onOpen, onClose = _a.onClose, onToggle = _a.onToggle;
    var forceOpen = useContext(DropdownDebugContext).forceOpen;
    var _b = useState(forceOpen), isOpen = _b[0], setIsOpen = _b[1];
    var wasOpen = useRef(false);
    var focusWasInDropdown = useRef(false);
    var openDropdown = useCallback(function () {
        if (isOpen || disabled) {
            return;
        }
        wasOpen.current = isOpen;
        focusWasInDropdown.current = false;
        setIsOpen(true);
        onOpen && onOpen();
        onToggle && onToggle(true);
    }, [disabled, isOpen, onOpen, onToggle]);
    var closeDropdown = useCallback(function () {
        if (!isOpen || disabled || forceOpen) {
            return;
        }
        wasOpen.current = isOpen;
        focusWasInDropdown.current =
            !!menuRef.current && menuRef.current.contains(document.activeElement);
        setIsOpen(false);
        onClose && onClose();
        onToggle && onToggle(false);
    }, [isOpen, disabled, forceOpen, menuRef, onClose, onToggle]);
    var toggleDropdown = useCallback(function () {
        if (isOpen) {
            closeDropdown();
        }
        else {
            openDropdown();
        }
    }, [closeDropdown, isOpen, openDropdown]);
    // set focus after state change
    useLayoutEffectWithoutSSRComplaining(function () {
        if (isOpen && !wasOpen.current) {
            // focus menu
            if (menuRef.current) {
                menuRef.current.focus({ preventScroll: true });
            }
        }
        if (!isOpen && wasOpen.current) {
            // focus toggle
            if (focusWasInDropdown.current && toggleRef.current) {
                toggleRef.current.focus({ preventScroll: true });
            }
        }
    }, [isOpen]);
    useDebugValue(isOpen ? 'Open' : 'Closed');
    return { isOpen: isOpen, openDropdown: openDropdown, closeDropdown: closeDropdown, toggleDropdown: toggleDropdown };
}
//# sourceMappingURL=useDropdownState.js.map